import { render, staticRenderFns } from "./Domicilio.vue?vue&type=template&id=88f2a020"
import script from "./Domicilio.vue?vue&type=script&lang=js"
export * from "./Domicilio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88f2a020')) {
      api.createRecord('88f2a020', component.options)
    } else {
      api.reload('88f2a020', component.options)
    }
    module.hot.accept("./Domicilio.vue?vue&type=template&id=88f2a020", function () {
      api.rerender('88f2a020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/Domicilio.vue"
export default component.exports